module.exports = __webpack_public_path__ + "static/media/rp04.c7a7d468.webp";